import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import DropdownTitle from '../dropdown/DropdownTitle'

function normalizeAuthors (authors, onFilterChange) {
  return authors.map(author => {
    return {
      title: author.username,
      value: author.id,
      onClick: onFilterChange
    }
  })
}

const AuthorSelector = ({ authors, selected, onFilterChange }) => {
  authors = normalizeAuthors(authors, onFilterChange)
  return <DropdownControl
    align={'adjust'}
    trigger={<ButtonControl title={selected ? <DropdownTitle label={'Author'} title={selected} /> : 'Select an author'} class={'filter qa-author-filter'} icon={'arrowDropdown'} />}
    items={authors}
  />
}

export default AuthorSelector
